import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, ServiceTypes, ServiceRequests } from 'src/app/interfaces/apiresponses';
import { DatePipe } from '@angular/common';

interface GetDocumentData {
  id: number;
  documentTypeId?: number;
  documentName: string;
  base64Data: string;
}

@Component({
  selector: 'app-support-admin',
  templateUrl: './support-admin.component.html',
  styleUrls: ['./support-admin.component.scss'],
  providers: [DatePipe]
})



export class SupportAdminComponent implements OnInit {
  bUndefined!: boolean
  selectedItem: any
  showUserForm = false;
  selectedUser: any;
  documents: GetDocumentData[] = [];

  selectedRequestId: number | null = null;
  selectedRequestType: string = '';

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  serviceTypes: any
  date = new Date();
  startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  columns = [
    {
      key: 'requestId',
      label: 'Request ID',
      filter: true
    },
    {
      key: 'dateCreated',
      label: 'Requested On',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'raisedByEmailId',
      label: 'Requested By',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'resolvedOn',
      label: 'Resolved On',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'resolveByEmailId',
      label: 'Resolved By',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'response',
      label: 'Resolution Given',
      _cellProps: { align: 'middle' },
      filter: false
    },
    {
      key: 'isOpen',
      label: 'Status',
      filter: false
    }
    // ,{
    //   key: 'action',
    //   label: 'Action',
    //   filter: false
    // },
  ];

  serviceData: IItem[] = []
  selectedItems = [2, 3];

  // Resolution Form
  bShowResolution = false
  bValidResolution!: boolean
  resolutionText: string = ''
  resolutionForm = new FormGroup({
    resolutionControl: new FormControl(this.resolutionText, [Validators.required, Validators.minLength(5)])
  })
  userForm!: FormGroup;
  raisedUserId!: string;

  get resolutionControl() { return this.resolutionForm.get('resolutionControl') }

  ifResolutionValid() {
    if (this.resolutionControl?.invalid && (this.resolutionControl?.dirty || this.resolutionControl?.touched)) {
      this.bValidResolution = false
      return 'Enter a valid resolution'
    } else {
      if (this.resolutionControl?.dirty || this.resolutionControl?.touched)
        this.bValidResolution = true
      else
        this.bValidResolution = this.bUndefined
      return ''
    }
  }

  showResolutionModal(item: any) {
    this.selectedItem = item
    this.resolutionControl?.setValue('')
    this.resolutionText = ''
    this.bValidResolution = this.bUndefined
    this.bShowResolution = true
  }

  closeResolutionModal() {
    this.bShowResolution = false
  }

  onStartDateChane(event: any) {
    this.startDate = event
    this.serviceData = []
  }

  onEndDateChane(event: any) {
    this.endDate = event
    this.serviceData = []
  }

  onSelectChange() {
    this.serviceData = []
  }

  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef) {

  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  getDateString(dateValue: Date) {
    return this.datePipe.transform(dateValue, "yyyy-MM-dd")
  }

  getDisplayDate(item: any) {
    return this.datePipe.transform(item.dateCreated, "dd-MM-yyyy")
  }

  ngOnInit() {
    this.loadServiceTypes()
  }

  loadServiceTypes() {
    this.restApi.getServiceTypes().subscribe({
      next: (v: ServiceTypes) => {
        if (v.success) {
          this.serviceTypes = v.serviceTypes

          if (this.selectedRequestType) {
            this.selectedRequestType = this.getRequestTypeLabel(this.selectedRequestType)
          }
        }
      },
      error: (e) => {

      }
    })
  }

  getRequestTypeLabel(requestType: string | null | undefined): string {
    if (!requestType) return ''

    const list: any[] = Array.isArray(this.serviceTypes) ? this.serviceTypes : []
    const match = list.find((t) => t?.value === requestType || t?.key === requestType)
    return match?.key ?? requestType
  }

  isClientCategoryUpdateRequest(): boolean {
    return (
      this.selectedItem?.requestType === 'Client Category Update Request' ||
      this.selectedRequestType === 'Client Category Update Request'
    )
  }

  setClientCategoryEditMode() {
    const clientCategoryControl = this.userForm?.get('clientCategory')
    if (!clientCategoryControl) return

    if (this.isClientCategoryUpdateRequest()) {
      clientCategoryControl.enable({ emitEvent: false })
    } else {
      clientCategoryControl.disable({ emitEvent: false })
    }
  }

  isRequestResolved(): boolean {
    return !!this.selectedItem && !this.selectedItem.isOpen
  }

  setRequestFormControlState() {
    const statusControl = this.userForm?.get('status')
    const resolutionControl = this.userForm?.get('resolutionGiven')
    const internalRemarksControl = this.userForm?.get('internalRemarks')
    const sendRemarksControl = this.userForm?.get('sendRemarksToCustomer')

    if (!statusControl || !resolutionControl || !internalRemarksControl || !sendRemarksControl) return

    if (this.isRequestResolved()) {
      statusControl.disable({ emitEvent: false })
      resolutionControl.disable({ emitEvent: false })
      internalRemarksControl.disable({ emitEvent: false })
      sendRemarksControl.disable({ emitEvent: false })
    } else {
      statusControl.enable({ emitEvent: false })
      resolutionControl.enable({ emitEvent: false })
      internalRemarksControl.enable({ emitEvent: false })
      sendRemarksControl.enable({ emitEvent: false })
    }
  }

  canUpdateForm(): boolean {
    return !!this.userForm && this.userForm.dirty && !this.isRequestResolved()
  }

  hasRequiredRemarks(status: string, internalRemarks: string, resolutionGiven: string): boolean {
    const internalRemarksValue = (internalRemarks || '').trim()
    const resolutionValue = (resolutionGiven || '').trim()

    if (status === 'Open') {
      if (!internalRemarksValue) {
        this.userForm?.get('internalRemarks')?.markAsTouched()
        this.showAlertBox('Validation', 'Internal Remarks are mandatory when Status is Open')
        return false
      }
    }

    if (status === 'Resolved') {
      if (!resolutionValue) {
        this.userForm?.get('resolutionGiven')?.markAsTouched()
        this.showAlertBox('Validation', 'Resolution Given is mandatory when Status is Resolved')
        return false
      }
    }

    return true
  }

  closeAlert(event: any) {

  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any) {
    this.bAlert = event.state
    if (event.data.action === 1) {
    }
  }

  // Search Form
  // Search Form
  searchServiceType: string = 'All'
  searchTicketType: string = 'All Tickets'

  cifSearchForm = new FormGroup({
    searchServiceTypeControl: new FormControl(this.searchServiceType),
    searchTicketTypeControl: new FormControl(this.searchTicketType),
  })

  get searchServiceTypeControl() { return this.cifSearchForm.get('searchServiceTypeControl') }
  get searchTicketTypeControl() { return this.cifSearchForm.get('searchTicketTypeControl') }

  getServices() {
    // If user is in details view, go back to results on Search
    this.showUserForm = false
    this.selectedItem = null
    this.selectedRequestId = null
    this.selectedRequestType = ''

    let showTicketType = 1

    if (this.searchServiceTypeControl?.value == null || this.searchServiceTypeControl?.value == '' || this.searchTicketTypeControl?.value == null || this.searchTicketTypeControl?.value == '') {
      this.showAlertBox('Sorry', 'Please choose the Service Type and Ticket Type before you can search')
      return
    } else {
      if (this.searchTicketTypeControl?.value == 'Open Tickets')
        showTicketType = 1
      else if (this.searchTicketTypeControl?.value == 'Closed Tickets')
        showTicketType = 2
      else
        showTicketType = 3

      let startDateString = this.getDateString(this.startDate)
      let endDateString = this.getDateString(this.endDate)

      if (startDateString != null && endDateString != null) {
        this.restApi.getServiceRequests(this.searchServiceTypeControl?.value, startDateString, endDateString, showTicketType, 1).subscribe({
          next: (v: ServiceRequests) => {
            this.serviceData = v.serviceRequests.map((item, Reference) => {
              const _selected = this.selectedItems.includes(Reference);
              return {
                ...item,
                _selected
              };
            })
          },
          error: (e) => {

          }
        })
      } else {
        this.showAlertBox('Sorry', 'Please correct the dates')
      }
    }
  }

  getStatusBadge(item: any) {
    if (item.isOpen)
      return 'danger'
    else
      return 'success'
  }

  getStatus(item: any) {
    if (item.isOpen)
      return 'Open'
    else
      return 'Resolved'
  }

  showResolveButton(item: any) {
    if (item.isOpen)
      return true
    else
      return false
  }

  getResolutionDate(item: any) {
    if (item.isOpen)
      return ''
    else
      return item.resolvedOn
  }

  getRowInternalRemarks(item: any): string {
    return item?.internalRemarks || item?.relevantData || ''
  }

  // processResolution() {
  //   this.resolutionControl?.markAsTouched()

  //   if (this.resolutionForm.valid && this.resolutionControl?.value != null) {
  //     this.restApi.resolveServiceRequest(this.selectedItem.requestId, this.resolutionControl?.value, "Resolved").subscribe({
  //       next: (v: GenericResponse) => {
  //         if (v.success) {
  //           this.bShowResolution = false
  //           this.getServices()
  //         } else {
  //           this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
  //         }
  //       },
  //       error: (e) => {
  //         this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
  //       }
  //     })
  //   } else {
  //     this.bValidResolution = false
  //   }
  // }

  onRowClick(rowData: any) {
    console.log('Row clicked:', rowData.item.raisedBy);
    const initialStatus = rowData.item.isOpen ? 'Open' : 'Resolved'
    const isInitiallyResolved = initialStatus === 'Resolved'
    const selectedRowInternalRemarks = this.getRowInternalRemarks(rowData.item)

    this.selectedItem = rowData.item
    this.raisedUserId = rowData.item.raisedBy;

    this.selectedRequestId = rowData.item.requestId
    this.selectedRequestType = this.getRequestTypeLabel(rowData.item.requestType)

    // Base details form (always available)
    this.userForm = new FormGroup({
      requestId: new FormControl({ value: this.selectedRequestId, disabled: true }),
      status: new FormControl({ value: initialStatus, disabled: false }),
      requestType: new FormControl({ value: this.selectedRequestType, disabled: true }),
      sendRemarksToCustomer: new FormControl({ value: isInitiallyResolved, disabled: isInitiallyResolved }),
      internalRemarks: new FormControl({ value: selectedRowInternalRemarks, disabled: false }),
      resolutionGiven: new FormControl({ value: rowData.item.response || '', disabled: false }),
      customerCIF: new FormControl({ value: '', disabled: true }),
      customerName: new FormControl({ value: '', disabled: true }),
      customerEmail: new FormControl({ value: '', disabled: true }),
      customerMobile: new FormControl({ value: '', disabled: true }),
      clientCategory: new FormControl({ value: '', disabled: true }),
      CustomerRemarks: new FormControl({ value: rowData.item.remark, disabled: true }),

    });

    this.userForm.get('status')?.valueChanges.subscribe((statusValue) => {
      const sendRemarksControl = this.userForm.get('sendRemarksToCustomer')
      if (!sendRemarksControl) return

      if (statusValue === 'Resolved') {
        sendRemarksControl.setValue(true, { emitEvent: false })
        sendRemarksControl.disable({ emitEvent: false })
      } else {
        sendRemarksControl.enable({ emitEvent: false })
        sendRemarksControl.setValue(false, { emitEvent: false })
      }
    })

    this.setClientCategoryEditMode()
    this.setRequestFormControlState()

    this.documents = [];
    this.showUserForm = true;

    // Load customer details for all request types (controls remain disabled except clientCategory for specific request type)
    this.restApi.getUserFormData(rowData.item.raisedBy).subscribe(
      (userData: any) => {
        if (userData) {
          this.userForm.patchValue({
            customerCIF: userData.cif,
            customerName: userData.fullName || '',
            customerEmail: userData.email || '',
            customerMobile: userData.mobile || '',
            clientCategory: userData.clientCategory || '',
            internalRemarks: this.userForm.get('internalRemarks')?.value || userData.relevantData || '',
          })
          if (rowData.item.requestType === "Client Category Update Request") {
            this.documents = userData.documents;
          }
          this.userForm.markAsPristine()
        }
      },
      (error) => {
        console.error('Error fetching user data:', error);
      }
    );
  }

  onUpdateClick() {
    if (!this.userForm || !this.selectedItem || !this.canUpdateForm()) return

    const status = this.userForm.get('status')?.value || 'Open'
    const resolutionGiven = this.userForm.get('resolutionGiven')?.value || ''
    const internalRemarks = this.userForm.get('internalRemarks')?.value || ''
    const sendRemarksToCustomer = !!this.userForm.get('sendRemarksToCustomer')?.value

    if (!this.hasRequiredRemarks(status, internalRemarks, resolutionGiven)) {
      return
    }

    const shouldSendEmail = sendRemarksToCustomer || (status === 'Resolved' && !!resolutionGiven.trim())

    const formData = {
      userID: this.raisedUserId,
      fullName: this.userForm.get('customerName')?.value || '',
      email: this.userForm.get('customerEmail')?.value || '',
      mobile: this.userForm.get('customerMobile')?.value || '',
      clientCategory: this.userForm.get('clientCategory')?.value || '',
      RelevantData: internalRemarks
    } 

    this.restApi.resolveServiceRequest(String(this.selectedItem.requestId), resolutionGiven, internalRemarks, status, shouldSendEmail).subscribe({
      next: (resolveResponse: GenericResponse) => {
        if (!resolveResponse.success) {
          this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
          return
        }
        if (this.isClientCategoryUpdateRequest()) {
          this.restApi.updateCustomersDetails(formData).subscribe({
            next: () => {
              if (status === 'Resolved') {
                this.selectedItem.isOpen = false
              }
              this.setRequestFormControlState()
              this.userForm.markAsPristine()
              this.showAlertBox('Success', 'Service request updated successfully')
            },
            error: () => {
              this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
            }
          })
        }
        else {
          this.showAlertBox('Success', 'Service request updated successfully')
        } 
      },
      error: () => {
        this.showAlertBox('Sorry', 'There was a technical issue. Please contact the support')
      }
    })
  }

  onUserFormSaveClick() {
    if (this.userForm.valid) {
      const formData = {
        userID: this.raisedUserId,
        fullName: this.userForm.get('customerName')?.value || '',
        email: this.userForm.get('customerEmail')?.value || '',
        mobile: this.userForm.get('customerMobile')?.value || '',
        clientCategory: this.userForm.get('clientCategory')?.value || '',
        RelevantData: this.userForm.get('internalRemarks')?.value || ''
      };

      this.restApi.updateCustomersDetails(formData).subscribe({
        next: (response) => {
          console.log('User form saved successfully:', response);
          alert('User data saved successfully!');
          this.showUserForm = false;
        },
        error: (error) => {
          console.error('Error saving user data:', error);
        }
      });
    } else {
      alert('Please fill in all required fields.');
    }
  }

  resetForm() {
    this.showUserForm = false;
    this.selectedRequestId = null;
    this.selectedRequestType = '';
    this.selectedItem = null
  }

  downloadDocument(documentData: GetDocumentData) {
    const byteCharacters = atob(documentData.base64Data);
    const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentData.documentName;
    link.click();
  }
}
